function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSinglePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8.273839mm",
    height: "10.377187mm",
    viewBox: "0 0 8.273839 10.377187",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-68.140438,-3.0459372)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.74835467,-7.2964581)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "M 76.666916,20.225119 69.384509,10.836858 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 69.384509,20.225119 7.282407,-9.38826 z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSinglePlus);
export default __webpack_public_path__ + "static/media/single-plus.1127694a5ccc2331e9cd852d5b806590.svg";
export { ForwardRef as ReactComponent };